import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AuthContext} from '../../contexts/auth/context';
import {AuthContextType} from '../../contexts/auth/types';
import {ScreenPaths} from '../../enums/screen-path';

interface Props {
  path: string;
  children: React.ReactNode;
}

/**
 * HOC for our public routes.
 */
const PublicRoute: React.FC<Props> = ({children, ...rest}) => {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({location}) => {
        let pathname = location.pathname.startsWith(ScreenPaths.LoginDailyCareLog)
          ? ScreenPaths.DailyCareLog
          : ScreenPaths.Office;

        // Quick Access Login Check
        if (location.pathname.startsWith('/login/quick-access')) {
          // Get last part of the path
          const pathParts = location.pathname.split('/');
          const navigationTarget = pathParts[pathParts.length - 1];

          // Eval
          if (navigationTarget === 'office') {
            // Set
            pathname = ScreenPaths.Office;
          } else if (navigationTarget === 'daily-care-log') {
            // Set
            pathname = ScreenPaths.DailyCareLog;
          }
        }

        return !authContext.state.firebaseUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname,
              state: {from: location},
            }}
          />
        );
      }}
    />
  );
};
export default PublicRoute;
